import { FC } from 'react'
import { ILocationBase } from '@/types'
import MarkerPinSvg from '@/public/images/common/marker-pin-01_v2.svg'
import styles from './index.module.scss'

type Props = {
  locations: ILocationBase[]
}

export const ProfileLocations: FC<Props> = ({ locations }) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <MarkerPinSvg viewBox='0 0 24 24' />
      </div>
      <div className={styles.locationList}>
        {locations?.map((location) => (
          <div key={location.id} className={styles.location}>
            {location.name}
          </div>
        ))}
      </div>
    </div>
  )
}
